import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { practicalInformationApi } from 'src/Services/API';

export const useRemovePracticalInformationAttachment = (
  options?: UseMutationOptions<
    void,
    unknown,
    { practicalInformationId: string; attachmentId: string }
  >
) => {
  const queryClient = useQueryClient();
  const assetId = useCurrentAssetId();

  return useMutation<void, unknown, { practicalInformationId: string; attachmentId: string }>(
    ['remove-practical-information-attachment', assetId],
    async ({ practicalInformationId, attachmentId }) => {
      if (!assetId) {
        throw new Error('No asset selected');
      }

      await practicalInformationApi.practicalInformationControllerRemoveAttachment(
        assetId,
        practicalInformationId,
        attachmentId
      );
    },
    {
      ...options,
      onSuccess: (data, variables, context) => {
        queryClient.invalidateQueries('fetch-all-practical-information');
        queryClient.invalidateQueries([
          'fetch-practical-information',
          assetId,
          variables.practicalInformationId,
        ]);
        options?.onSuccess?.(data, variables, context);
      },
    }
  );
};
